import { dataFourQuarterCirclesSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconFourQuarterCirclesSolid = /*#__PURE__*/createIcon(dataFourQuarterCirclesSolid)
export default IconFourQuarterCirclesSolid
